var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('app-screen',[(_vm.showGroupTree)?_c('template',{slot:"aside"},[_c('user-group-tree',{staticClass:"mt-3"})],1):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }